// src/pages/ContactUs.jsx
import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import PolicyLayout from "../components/common/PolicyLayout";
import "../components/common/styles/policyPages.css";


const ContactUs = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: integrate with backend / API
  };

  return (
    <PolicyLayout
      title="Contact Us"
      subtitle="We'd love to hear from you. Share your queries, feedback, or support requests.">
      <Container className="px-0">
        <Row className="g-4">
          <Col lg={7}>
            <div className="contact-card">
              <h3 className="policy-section-title mb-3">Send us a message</h3>
              <p className="policy-section-text">
                Fill out the form below and our team will get back to you as
                soon as possible.
              </p>

              <Form onSubmit={handleSubmit} className="mt-3">
                <Row className="g-3">
                  <Col md={6}>
                    <Form.Group controlId="contactName">
                      <Form.Label>Full Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter your full name"
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="contactEmail">
                      <Form.Label>Email Address</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="you@example.com"
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="g-3 mt-1">
                  <Col md={6}>
                    <Form.Group controlId="contactPhone">
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        type="tel"
                        placeholder="Enter your phone number"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="contactSubject">
                      <Form.Label>Subject</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="How can we help you?"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group controlId="contactMessage" className="mt-3">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="Write your message here..."
                    required
                  />
                </Form.Group>

                <div className="d-flex justify-content-center mt-4">
                  <Button type="submit" className="btn-msz">
                    Submit
                  </Button>
                </div>
              </Form>
            </div>
          </Col>

          <Col lg={5}>
            <div className="contact-info-card h-100">
              <h5>Get in touch</h5>
              <p className="policy-section-text" style={{ color: "#E5E7EB" }}>
                You can reach us using the details below. Our support team will
                try to respond at the earliest.
              </p>

              <div className="contact-info-item">
                <span className="contact-info-label">Email</span>
                <span className="contact-info-value">
                  connectus@mszila.in
                </span>
              </div>

              <div className="contact-info-item">
                <span className="contact-info-label">Phone</span>
                <span className="contact-info-value">Contact US - 9997427354</span>
              </div>

              <div className="contact-info-item">
                <span className="contact-info-label">Business Hours</span>
                <span className="contact-info-value">
                  Monday – Saturday, 10:00 AM – 7:00 PM
                </span>
              </div>

              <div className="contact-info-item">
                <span className="contact-info-label">Address</span>
                <span className="contact-info-value">
                  Building No./Flat No.: NO1188,
Road/Street: KHARPARI,
City/Town/Village: Mainpuri,
District: Mainpuri,
State: Uttar Pradesh,
PIN Code: 205001
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </PolicyLayout>
  );
};

export default ContactUs;
